import styled from 'styled-components';

export const FloorContainer = styled.div`
  display:flex;
  width: max(350px,32vw);
  height: max(380px,36.5vw);
`

export const Flex = styled.div`
  display:flex;
`
export const C1 = styled.div`
  height: 100%;
  width: 35%;
  cursor: pointer;
  box-shadow: inset 0px 0px 0px 1px black;
  background-color: ${props => props.inputColor || "white"};
`

export const C2 = styled.div`
  height: 100%;
  width: 54.5%;
  cursor: pointer;
  background-color: ${props => props.inputColor || "white"};
  box-shadow: inset 0px 0px 0px 1px black;
  display:flex;
  justify-content:center;
  align-items: center;
`

export const C3 = styled.div`
  height: 100%;
  cursor: pointer;
  width: 45.5%;
  text-align: center;
  background-color: ${props => props.inputColor || "white"};
  box-shadow: inset 0px 0px 0px 1px black;
  display:flex;
  justify-content:center;
  align-items: center;
`

export const C4 = styled.div`
  height: 100%;
  width: 54.5%;
  text-align: center;
  background-color: ${props => props.inputColor || "white"};
  box-shadow: inset 0px 0px 0px 1px black;
  display:flex;
  justify-content:center;
  align-items: center;
`

export const C5 = styled.div`
  cursor: pointer;
  height: 100%;
  width: 45.5%;
  text-align: center;
  background-color: ${props => props.inputColor || "white"};
  box-shadow: inset 0px 0px 0px 1px black;
  display:flex;
  justify-content:center;
  align-items: center;
`

export const C6 = styled.div`
  height: 100%;
  cursor: pointer;
  width: 100%;
  text-align: center;
  background-color: ${props => props.inputColor || "white"};
  box-shadow: inset 0px 0px 0px 1px black;
  display:flex;
  justify-content:center;
  align-items: center;
`

export const C11 = styled.div`
  height: 100%;
  width: 35%;
  display: flex;
  justify-content:center;
  align-items: center;
  cursor: pointer;
  border-top:1px solid;
  border-left:1px solid;
  border-bottom:1px solid;
  background-color: ${props => props.inputColor || "white"};
`

export const C21 = styled.div`
  height: 33.33%;
  width: 100%;
  cursor: pointer;
  background-color: ${props => props.inputColor || "white"};
  border-top:1px solid;
  display:flex;
  justify-content:center;
  align-items: center;
`

export const C31 = styled.div`
  height: 100.5%;
  cursor: pointer;
  width: 45.5%;
  text-align: center;
  background-color: ${props => props.inputColor || "white"};
  box-shadow: inset 0px 0px 0px 1px black;
  display:flex;
  justify-content:center;
  align-items: center;
`

export const C41 = styled.div`
  height: 33.33%;
  width: 100%;
  text-align: center;
  background-color: ${props => props.inputColor || "white"};
  border-top:1px solid;
  border-left:1px solid;
  border-bottom:1px solid;

  display:flex;
  justify-content:center;
  align-items: center;
`

export const C51 = styled.div`
  cursor: pointer;
  height: 32.8%;
  width: 100%;
  text-align: center;
  background-color: ${props => props.inputColor || "white"};
  display:flex;
  justify-content:center;
  align-items: center;
  border-bottom:1px solid;
`

export const C12 = styled.div`
  height: 100%;
  width: 35%;
  display: flex;
  justify-content:center;
  align-items: center;
  cursor: pointer;
  border-top:1px solid;
  border-left:1px solid;
  border-bottom:1px solid;
  background-color: ${props => props.inputColor || "white"};
`

export const C22 = styled.div`
  height: 33.33%;
  width: 100%;
  cursor: pointer;
  background-color: ${props => props.inputColor || "white"};
  border-top:1px solid;
  display:flex;
  justify-content:center;
  align-items: center;
`

export const C32 = styled.div`
  height: 100%;
  cursor: pointer;
  width: 45.5%;
  text-align: center;
  background-color: ${props => props.inputColor || "white"};
  display:flex;
  justify-content:center;
  align-items: center;
  border-top:1px solid;
  border-right:1px solid;
  border-bottom:1px solid;
`

export const C42 = styled.div`
  height: 33.33%;
  width: 100%;
  text-align: center;
  background-color: ${props => props.inputColor || "white"};
  box-shadow: inset 0px 0px 0px 1px black;
  display:flex;
  justify-content:center;
  align-items: center;
`

export const C52 = styled.div`
  cursor: pointer;
  height: 33.33%;
  width: 100%;
  text-align: center;
  background-color: ${props => props.inputColor || "white"};
  display:flex;
  justify-content:center;
  align-items: center;
  border-bottom:1px solid;
`
